import { ROLE_STATE_NAME, RoleState } from 'projects/access-control/src/app/Infrastructure/Store/role/role.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRoleState = createFeatureSelector<RoleState>(ROLE_STATE_NAME);
export const setRoles = createSelector(selectRoleState, (form: RoleState) => form.roles);
